var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "speech-settings-tab" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "a-form",
        { staticClass: "settings-form", attrs: { layout: "vertical" } },
        [
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Arka Plan Sesi")]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Arka Plan Sesi" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.updateSettings },
                      model: {
                        value: _vm.formData.ambient_sound,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "ambient_sound", $$v)
                        },
                        expression: "formData.ambient_sound",
                      },
                    },
                    _vm._l(_vm.backgroundSoundOptions, function (sound) {
                      return _c(
                        "a-select-option",
                        { key: sound.value, attrs: { value: sound.value } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(sound.label) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      '\n                    Arkaplan sesini belirleyin. Herhangi bir arka plan sesi istemiyorsanız "Yok" seçeneğini seçin.\n                '
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.ambient_sound
                ? _c(
                    "a-form-item",
                    { attrs: { label: "Arka Plan Sesi Seviyesi" } },
                    [
                      _c(
                        "div",
                        { staticClass: "slider-container" },
                        [
                          _c("a-slider", {
                            staticClass: "volume-slider",
                            attrs: { min: 0, max: 1, step: 0.1 },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: _vm.formData.ambient_sound_volume,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "ambient_sound_volume",
                                  $$v
                                )
                              },
                              expression: "formData.ambient_sound_volume",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-input-number", {
                            attrs: { min: 0, max: 1, step: 0.1 },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: _vm.formData.ambient_sound_volume,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "ambient_sound_volume",
                                  $$v
                                )
                              },
                              expression: "formData.ambient_sound_volume",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "description" }, [
                        _vm._v(
                          "Arka plan sesinin seviyesini ayarlayın (0-1 arası değer)."
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Konuşma Davranışı")]),
              ]),
              _vm._v(" "),
              _c("a-form-item", { attrs: { label: "Yanıt Verme Hızı" } }, [
                _c(
                  "div",
                  { staticClass: "slider-container" },
                  [
                    _c("a-slider", {
                      staticClass: "responsive-slider",
                      attrs: { min: 0, max: 1, step: 0.05 },
                      on: { change: _vm.updateSettings },
                      model: {
                        value: _vm.formData.responsiveness,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "responsiveness", $$v)
                        },
                        expression: "formData.responsiveness",
                      },
                    }),
                    _vm._v(" "),
                    _c("a-input-number", {
                      attrs: { min: 0, max: 1, step: 0.05 },
                      on: { change: _vm.updateSettings },
                      model: {
                        value: _vm.formData.responsiveness,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "responsiveness", $$v)
                        },
                        expression: "formData.responsiveness",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    Ajanın ne kadar hızlı yanıt vereceğini belirler. Düşük değer daha az tepkili (daha uzun bekler,\n                    daha yavaş yanıt verir), yüksek değer daha hızlı iletişim (yapabildiği anda yanıt verir)\n                    anlamına gelir.\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("a-form-item", { attrs: { label: "Kesinti Hassasiyeti" } }, [
                _c(
                  "div",
                  { staticClass: "slider-container" },
                  [
                    _c("a-slider", {
                      staticClass: "sensitivity-slider",
                      attrs: { min: 0, max: 1, step: 0.05 },
                      on: { change: _vm.updateSettings },
                      model: {
                        value: _vm.formData.interruption_sensitivity,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData,
                            "interruption_sensitivity",
                            $$v
                          )
                        },
                        expression: "formData.interruption_sensitivity",
                      },
                    }),
                    _vm._v(" "),
                    _c("a-input-number", {
                      attrs: { min: 0, max: 1, step: 0.05 },
                      on: { change: _vm.updateSettings },
                      model: {
                        value: _vm.formData.interruption_sensitivity,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData,
                            "interruption_sensitivity",
                            $$v
                          )
                        },
                        expression: "formData.interruption_sensitivity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    Ajanın kullanıcı kesintilerine ne kadar duyarlı olduğunu belirler. Düşük değer, kullanıcının\n                    ajanı kesmesinin daha uzun süreceği anlamına gelir, yüksek değer kullanıcının ajanı daha kolay\n                    kesmesini sağlar. 0 değeri asla kesilmez anlamına gelir.\n                "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Ara Kanal (Backchannel) Ayarları")]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    '\n                    Ajan, "evet", "hı hı" gibi ifadelerle dinlediğini belirterek daha doğal bir konuşma akışı\n                    sağlar.\n                '
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Ara Kanal Etkinleştirme" } },
                [
                  _c("a-switch", {
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.enable_backchannel,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "enable_backchannel", $$v)
                      },
                      expression: "formData.enable_backchannel",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "Ajan, konuşmacıya ilgi ve katılım belirtmek için araya girebilir."
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.enable_backchannel
                ? _c(
                    "div",
                    { staticClass: "backchannel-settings" },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "Ara Kanal Sıklığı" } },
                        [
                          _c(
                            "div",
                            { staticClass: "slider-container" },
                            [
                              _c("a-slider", {
                                staticClass: "frequency-slider",
                                attrs: { min: 0, max: 1, step: 0.1 },
                                on: { change: _vm.updateSettings },
                                model: {
                                  value: _vm.formData.backchannel_frequency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "backchannel_frequency",
                                      $$v
                                    )
                                  },
                                  expression: "formData.backchannel_frequency",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "slider-value" }, [
                                _vm._v(
                                  _vm._s(_vm.formData.backchannel_frequency)
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "\n                        Ajanın ne sıklıkla ara kanal ifadeleri kullanacağını belirler (0-1 arası değer).\n                    "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Ara Kanal Kelimeleri" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                mode: "tags",
                                placeholder:
                                  "Ajanın kullanacağı ara kanal kelimelerini girin",
                              },
                              on: { change: _vm.updateSettings },
                              model: {
                                value: _vm.formData.backchannel_words,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "backchannel_words",
                                    $$v
                                  )
                                },
                                expression: "formData.backchannel_words",
                              },
                            },
                            _vm._l(
                              _vm.defaultBackchannelWords,
                              function (word) {
                                return _c(
                                  "a-select-option",
                                  { key: word, attrs: { value: word } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(word) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              "\n                        Ajanın kullanacağı ara kanal kelimelerini belirleyin (çoklu seçim yapabilir veya kendiniz\n                        ekleyebilirsiniz).\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Gürültü Azaltma Ayarları")]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    İstenmeyen arka plan gürültüsü veya konuşmasını filtreleyin.\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("a-form-item", { attrs: { label: "Gürültü Azaltma Modu" } }, [
                _c(
                  "div",
                  { staticClass: "radio-group-container" },
                  [
                    _c(
                      "a-radio-group",
                      {
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.denoising_mode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "denoising_mode", $$v)
                          },
                          expression: "formData.denoising_mode",
                        },
                      },
                      [
                        _c("div", { staticClass: "radio-option" }, [
                          _c(
                            "div",
                            { staticClass: "radio-header" },
                            [
                              _c(
                                "a-radio",
                                { attrs: { value: "noise-cancellation" } },
                                [
                                  _c("span", { staticClass: "radio-label" }, [
                                    _vm._v("Gürültü İptali"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-description" }, [
                            _vm._v(
                              "İstenmeyen arka plan gürültüsünü filtreler"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "radio-option" }, [
                          _c(
                            "div",
                            { staticClass: "radio-header" },
                            [
                              _c(
                                "a-radio",
                                {
                                  attrs: {
                                    value:
                                      "noise-and-background-speech-cancellation",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "radio-label" }, [
                                    _vm._v(
                                      "Gürültü + Arka Plan Konuşması İptali"
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-tooltip",
                                {
                                  attrs: {
                                    placement: "right",
                                    title:
                                      "TV'deki insan sesleri gibi arka plan konuşmalarını kaldırır, agresif gürültü azaltma ile bazı senaryolarda transkripsiyon doğruluğunu azaltabilir",
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons info-icon" },
                                    [_vm._v("info_outline")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-description" }, [
                            _vm._v("Arka plan konuşmalarını da filtreler"),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Transkripsiyon Ayarları")]),
              ]),
              _vm._v(" "),
              _c("a-form-item", { attrs: { label: "Transkripsiyon Modu" } }, [
                _c(
                  "div",
                  { staticClass: "radio-group-container" },
                  [
                    _c(
                      "a-radio-group",
                      {
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.stt_mode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "stt_mode", $$v)
                          },
                          expression: "formData.stt_mode",
                        },
                      },
                      [
                        _c("div", { staticClass: "radio-option" }, [
                          _c(
                            "div",
                            { staticClass: "radio-header" },
                            [
                              _c("a-radio", { attrs: { value: "fast" } }, [
                                _c("span", { staticClass: "radio-label" }, [
                                  _vm._v("Hız için optimize et"),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-description" }, [
                            _vm._v(
                              "Daha hızlı yanıt süresi için optimize edilmiş"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "radio-option" }, [
                          _c(
                            "div",
                            { staticClass: "radio-header" },
                            [
                              _c("a-radio", { attrs: { value: "accurate" } }, [
                                _c("span", { staticClass: "radio-label" }, [
                                  _vm._v("Doğruluk için optimize et"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-tooltip",
                                {
                                  attrs: {
                                    placement: "right",
                                    title:
                                      "Bu ayar bazen 200ms ek gecikmeye neden olabilir",
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons info-icon" },
                                    [_vm._v("info_outline")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-description" }, [
                            _vm._v(
                              "Daha doğru transkripsiyon için optimize edilmiş"
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Güçlendirilmiş Anahtar Kelimeler" } },
                [
                  _c("a-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      mode: "tags",
                      placeholder:
                        "Tanıma hassasiyetini artırmak için anahtar kelimeler girin",
                    },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.boosted_keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "boosted_keywords", $$v)
                      },
                      expression: "formData.boosted_keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    Konuşma tanımada daha iyi algılanması için güçlendirilecek kelimeleri belirleyin.\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Konuşma Normalleştirmeyi Etkinleştir" } },
                [
                  _c(
                    "div",
                    { staticClass: "switch-container" },
                    [
                      _c("a-switch", {
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.normalize_for_speech,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "normalize_for_speech", $$v)
                          },
                          expression: "formData.normalize_for_speech",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            placement: "right",
                            title:
                              "Bu ayar ortalama 100ms ek gecikmeye neden olabilir",
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons info-icon" }, [
                            _vm._v("info_outline"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    Etkinleştirildiğinde, metin içindeki sayı, para birimi, tarih vb. öğeleri konuşma biçimine\n                    dönüştürür.\n                "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Transkript Formatlamayı Etkinleştir" } },
                [
                  _c("a-switch", {
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.enable_transcription_formatting,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "enable_transcription_formatting",
                          $$v
                        )
                      },
                      expression: "formData.enable_transcription_formatting",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    Etkinleştirildiğinde, transkripsiyon sayı, tarih, e-posta vb. biçimlerde formatlanır.\n                "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Hatırlatma Mesajı Ayarları")]),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Hatırlatma Tetikleme Süresi (ms)" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 5000, max: 60000, step: 1000 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.reminder_trigger_ms,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "reminder_trigger_ms", $$v)
                      },
                      expression: "formData.reminder_trigger_ms",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    Kullanıcı sessiz kaldığında hatırlatma mesajı gönderilmeden önceki milisaniye cinsinden süre.\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                { attrs: { label: "Maksimum Hatırlatma Sayısı" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, max: 5, step: 1 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.reminder_max_count,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "reminder_max_count", $$v)
                      },
                      expression: "formData.reminder_max_count",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v("Gönderilecek maksimum hatırlatma mesajı sayısı."),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("h4", [_vm._v("Telaffuz Sözlüğü")]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    Ajanın tutarlı telaffuz etmesi için kelime ve cümleleri tanımlayın (Şu an için sadece İngilizce\n                    ve 11labs sesleri için desteklenir).\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.formData.pronunciation_dictionary,
                function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "pronunciation-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "pronunciation-row" },
                        [
                          _c("a-input", {
                            staticStyle: { width: "30%" },
                            attrs: { placeholder: "Kelime" },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: item.word,
                              callback: function ($$v) {
                                _vm.$set(item, "word", $$v)
                              },
                              expression: "item.word",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "20%" },
                              on: { change: _vm.updateSettings },
                              model: {
                                value: item.alphabet,
                                callback: function ($$v) {
                                  _vm.$set(item, "alphabet", $$v)
                                },
                                expression: "item.alphabet",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "ipa" } },
                                [_vm._v("IPA")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "cmu" } },
                                [_vm._v("CMU")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("a-input", {
                            staticStyle: { width: "40%" },
                            attrs: { placeholder: "Fonem" },
                            on: { change: _vm.updateSettings },
                            model: {
                              value: item.phoneme,
                              callback: function ($$v) {
                                _vm.$set(item, "phoneme", $$v)
                              },
                              expression: "item.phoneme",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-button", {
                            staticStyle: { width: "10%" },
                            attrs: { type: "danger", icon: "delete" },
                            on: {
                              click: function ($event) {
                                return _vm.removePronunciation(index)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-pronunciation" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "dashed", block: "" },
                      on: { click: _vm.addPronunciation },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(" Telaffuz Ekle\n                "),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.update"] } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.isSaving },
                      on: { click: _vm.saveSettings },
                    },
                    [
                      _vm._v(
                        "\n                    Değişiklikleri Kaydet\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-header" }, [
      _c("h3", [_vm._v("Konuşma Ayarları")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Bu sekme ajanın ses ve konuşma özelliklerini yapılandırmanızı sağlar."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }